export function initFilters(): void {
  const bar = document.querySelector<HTMLElement>('[data-filter-bar]')
  const grid = document.querySelector<HTMLElement>('[data-product-grid]')
  if (!bar || !grid) return

  const form = bar.querySelector<HTMLFormElement>('[data-filter-form]')
  const sort = bar.querySelector<HTMLSelectElement>('[data-filter-sort]')
  const countEl = document.querySelector<HTMLElement>('[data-collection-count]')

  function buildUrl(): string {
    const params = new URLSearchParams()
    if (form) {
      // Group checkboxes by filter name. If every option in a group is checked,
      // that's semantically "no filter" — drop the whole group. Shopify's
      // `filter.v.availability` returns zero when both 1 and 0 are submitted.
      const groups = new Map<string, { total: number; checked: HTMLInputElement[] }>()
      for (const el of form.querySelectorAll<HTMLInputElement>('input[type="checkbox"]')) {
        const g = groups.get(el.name) ?? { total: 0, checked: [] }
        g.total += 1
        if (el.checked) g.checked.push(el)
        groups.set(el.name, g)
      }
      for (const [, g] of groups) {
        if (g.checked.length === 0) continue
        if (g.checked.length === g.total) continue
        for (const el of g.checked) params.append(el.name, el.value)
      }
    }
    if (sort?.value) params.set('sort_by', sort.value)
    const qs = params.toString()
    return qs ? `${window.location.pathname}?${qs}` : window.location.pathname
  }

  let reqId = 0
  async function applyFilters(): Promise<void> {
    const myReq = ++reqId
    const url = buildUrl()

    // Push the URL immediately so the back button + share-on-refresh work
    window.history.replaceState({}, '', url)
    grid!.style.transition = 'opacity 0.18s ease'
    grid!.style.opacity = '0.4'

    // Cache-buster prevents stale CDN responses for the same URL
    const sep = url.includes('?') ? '&' : '?'
    const fetchUrl = `${url}${sep}_=${Date.now()}`
    let html = ''
    try {
      const res = await fetch(fetchUrl, {
        headers: { Accept: 'text/html' },
        cache: 'no-store',
        credentials: 'same-origin',
      })
      html = await res.text()
    } catch (err) {
      console.error('[filters] fetch failed', err)
      grid!.style.opacity = '1'
      return
    }
    if (myReq !== reqId) return // a newer request superseded this one

    const doc = new DOMParser().parseFromString(html, 'text/html')
    const newGrid = doc.querySelector<HTMLElement>('[data-product-grid]')
    if (newGrid) {
      grid!.innerHTML = newGrid.innerHTML
      // Cards inside use .reveal which is opacity:0 until IntersectionObserver
      // fires .is-visible. AJAX-swapped cards are already in viewport, so the
      // observer never triggers — mark them visible immediately.
      grid!.querySelectorAll<HTMLElement>('.reveal').forEach((el) => {
        el.classList.add('is-visible')
      })
    }

    if (countEl) {
      const newCount = doc.querySelector<HTMLElement>('[data-collection-count]')
      if (newCount) countEl.textContent = newCount.textContent
    }

    requestAnimationFrame(() => {
      grid!.style.opacity = '1'
    })
  }

  form?.addEventListener('change', applyFilters)
  sort?.addEventListener('change', applyFilters)
}
